import React from 'react'
import { RiHome5Line, RiLogoutCircleRLine } from 'react-icons/ri'
import { GiMoneyStack } from 'react-icons/gi'
import { TbBusinessplan, TbList } from 'react-icons/tb'
import { RiBankLine } from 'react-icons/ri'
import { useNavigate } from 'react-router-dom'
import { useGlobalContext } from '../../../../Context/Context'
import './Sidebar.scss'

interface prop {
  page: any
}
function Sidebar({ page }: prop) {
  const navigate = useNavigate()
  const { toggleSidebar, handleSidebarToggle } = useGlobalContext()

  return (
    <div className={toggleSidebar ? 'sidebar' : 'sidebar active'}>
      <div className='columns'>
        <div
          className={page === 'home' ? 'row active' : 'row'}
          onClick={() => {
            navigate('/dashboard/home')
            handleSidebarToggle()
          }}
        >
          <div className='icon'>
            <RiHome5Line />
          </div>
          <p>Dashboard</p>
        </div>
        <div
          className={page === 'deposit' ? 'row active' : 'row'}
          onClick={() => {
            navigate('/dashboard/deposit')
            handleSidebarToggle()
          }}
        >
          <div className='icon'>
            <RiBankLine />
          </div>
          <p>Deposits</p>
        </div>
        {/* <div
          className={page === 'investment' ? 'row active' : 'row'}
          onClick={() => {
            navigate('/dashboard/investment')
            handleSidebarToggle()
          }}
        >
          <div className='icon'>
            <RiExchangeFundsFill />
          </div>
          <p>Investments</p>
        </div> */}
        <div
          className={page === 'plan' ? 'row active' : 'row'}
          onClick={() => {
            navigate('/dashboard/plan')
            handleSidebarToggle()
          }}
        >
          <div className='icon'>
            <TbBusinessplan />
          </div>
          <p>Plans</p>
        </div>
        <div
          className={page === 'transaction' ? 'row active' : 'row'}
          onClick={() => {
            navigate('/dashboard/transaction')
            handleSidebarToggle()
          }}
        >
          <div className='icon'>
            <TbList />
          </div>
          <p>Transactions</p>
        </div>
        <div
          className={page === 'withdraw' ? 'row active' : 'row'}
          onClick={() => {
            navigate('/dashboard/withdraw')
            handleSidebarToggle()
          }}
        >
          <div className='icon'>
            <GiMoneyStack />
          </div>
          <p>Withdrawal</p>
        </div>
        <div
          className='row'
          onClick={() => {
            navigate('/login')
            sessionStorage.clear()
          }}
        >
          <div className='icon'>
            <RiLogoutCircleRLine />
          </div>
          <p>Logout</p>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
